import React, { type FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';

import { Card } from 'components/Shared/Card';
import { Button } from 'components/Shared/Inputs';
import { StepDefinition } from 'components/ToDos/constants';
import { type ToDo } from '../../interfaces';
import { getToDoLink } from '../../utils';

import './ToDoCard.scss';

interface ToDoCardProps {
    toDo: ToDo
}

export const ToDoCard: FC<ToDoCardProps> = (props) => {
    const { toDo } = props;
    const { t, ready: translationsReady } = useTranslation('todos', { useSuspense: false });
    let buttonText = t(`${toDo?.step?.toString()}-button`);
    let todoLabel = t(`${toDo.step.toString()}-title`, { replace: { clientName: toDo?.activityInfo?.clientName }});
    let todoLink = getToDoLink(toDo);
    
    return (
        translationsReady
            ? <Card elevation={1} className="todo_card">
                <div className="todo_card_content">
                    <h3 id={`title_field_${toDo.id}`} className="card_title">
                        {todoLabel}
                    </h3>
                    <div className="todo_card_actions_container">
                        <Button
                            variant="opaque"
                            component={Link}
                            to={todoLink}
                            state={{ workflowId: toDo.id, activity: toDo.activityInfo, isMultiReferral: toDo.step === StepDefinition.CONFIRM_MULTI_REFERRAL, fromToDo: true }}
                        >
                            {buttonText}
                        </Button>
                    </div>
                </div>
            </Card>
            : <></>
    )
};

export const ToDoCardSkeleton: React.FC = () => (
    <Card elevation={0} className="todo_card skeleton">
        <div className="todo_card_content">
            <Skeleton variant="text" width="90%" className="card_title" />
            <br />
            <div className="todo_card_actions_container">
                <Skeleton variant="rounded" width={100} height={36} />
            </div>
        </div>
    </Card>
);
